import { useState, useEffect } from 'react';
import { Company } from '../../../types/career';
import { config } from '../../../utils/config';

interface CareerData {
  companies: Company[];
}

interface UseCareerDataResult {
  companies: Company[];
  loading: boolean;
  error: string | null;
}

export const useCareerData = (): UseCareerDataResult => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.staticUrl}/career-data.json`);
        if (!response.ok) {
          throw new Error(`Failed to load career data: ${response.status}`);
        }
        const data: CareerData = await response.json();
        setCompanies(data.companies);
        setLoading(false);
      } catch (err) {
        console.error('Error loading career data:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { companies, loading, error };
};
